module.exports = __webpack_public_path__ + "media/ask/section-bottom-01-c992079a.svg";